<template>
  <div>
    <div class="dataTime">
      <span class="demonstration">{{ $t("common.date") }}</span>
      <el-date-picker
        v-model="changeValue"
        value-format="yyyy-MM-dd"
        type="daterange"
        :range-separator="$t('common.to')"
        :start-placeholder="$t('common.starDate')"
        :end-placeholder="$t('common.endDate')"
        @change="changeTime"
      >
      </el-date-picker>
    </div>
    <div class="dataEchart">
      <div style="padding: 10px 0 0 10px; color: #fff; font-size: 18px">
        <!-- {{$t('BatteryAnalysis.chargeAndDischargeTimeH')}} -->
        {{ $t('ChangeTime.maintenanceItemCount') }}
      </div>
      <div v-loading="amountLoading">
        <linegraph
          :id="'linegraph'"
          :data="amountOption"
          style="height: 310px"
        ></linegraph>
      </div>
    </div>
    <div class="dataTable">
      <div class="table-title">
        <!-- {{$t('BatteryAnalysis.carUseDetail')}} -->
        {{ $t('ChangeTime.maintenanceItemDetail') }}
      </div>
      <div class="rightAll-btn">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('VehicleManagement.maintenanceItems')">
            <el-cascader
              v-model="formInline.projectId"
              :options="options"
              @change="handleChange"
            ></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-button
              size="mini"
              type="primary"
              @click="onSearch"
              class="btn-chaxun"
              >{{ $t("common.btn.search") }}</el-button
            >
            <el-button size="mini" @click="onClear" class="btn-del">{{
              $t("common.btn.cancel")
            }}</el-button>
          </el-form-item>
        </el-form>
        <el-button
          v-if="isPrimaryKey('BATTERYANALYSIS_DOWN')"
          type="text"
          @click="downCar"
          >{{ $t("common.btn.download") }}</el-button
        >
      </div>
      <i-table
        :list="list"
        ref="carTable"
        @handleSelectionChange="handleSelectionChange"
        :options="option"
        :columns="columns"
        :operates="operates"
      ></i-table>
      <IPagination ref="page" @PageFun="changeSize"></IPagination>
    </div>
  </div>
</template>

<script>
import ChangeTime from "./ChangeTime";
export default ChangeTime;
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/Style.less";
</style>
